define('views/modules/profile/edit/personal-info-edit-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'bootbox',
    // views
    'src/views/form-view',
    'views/parts/menu/menu-save-action',
    'views/modules/profile/edit/account-info-edit-form',
    'views/modules/profile/edit/account-settings-edit-form',
    'views/modules/profile/edit/personal-info-edit-form',
    // services
    'services/i18n',
    // templates
    'text!templates/modules/profile/edit/profile-edit-content.html',
], function(
    // Libs
    _, Backbone, Mustache, U, Bootbox,
    // views
    VForm,
    VMenuSaveAction,
    VAccountInfoEditForm,
    VAccountSettingsEditForm,
    VPersonnalInfoEditForm,
    // services
    i18n,
    // templates
    TPersonalInfoEditContent
) {

    var VPersonalInfoEditContent = VForm.extend({
        fields: ['firstname', 'lastname', 'email', 'password', 'language', 'gender', 'birthdate', 'phone', 'country', 'province', 'city', 'timezone', 'height'],
        template: TPersonalInfoEditContent,

        regions: {
            root: "#profile-edit-content",
            menu: ".menu-actions",
            account_info: ".account-info-edit-form",
            personal_info: ".personal-info-edit-form",
        },

        initialize: function(options) {
            this.view = {
                menu: new VMenuSaveAction({
                    context: this,
                    onClick: this.onActionClick,
                    onSave: this.onSaveButton,
                    saveText: "Save",
                    radio: false,
                    tooltip: { container: this.regions.root, }
                }),
                account_info: new VAccountInfoEditForm({ model: this.model }),
                personal_info: new VPersonnalInfoEditForm({ model: this.model })
            };

            this.originalLanguage = this.model.get('language').replace('_', '-');
            this.listenTo(this.model, { 'change': this.onModelChange });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu)
                .assign(view.account_info, zone.$account_info)
                .assign(view.personal_info, zone.$personal_info);

            return this;
        },

        onActionClick: function(e) {
            e.preventDefault();
        },

        onModelChange: function() {
            this.view.menu.toggleSaveButton(!this.isDirty());
        },

        onSaveButton: function() {
            var phoneNbr = this.view.personal_info.view.form.phone.getValue();

            this.model.set("email", this.model.get("email").trim());

            if (_.isEmpty(phoneNbr)) {
                this.submit();
                if (this.originalLanguage !== this.model.get('language').replace('_', '-')) {
                    Bootbox.confirm({
                        message: i18n.t("refresh-modal-message"),
                        onEscape: true,
                        backdrop: true,
                        callback:  this.onRefreshConfirm,
                        context: this,
                    });
                }
            } else {
                //var rgx = /^[+]\d{1}-\d{3}-\d{3}-\d{4}$/g;
                var rgx = /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?[\-\.\ \\\/]?(\d+))?$/g;
                if (rgx.test(phoneNbr)) {
                    this.submit();
                }
            }
        },

        onSuccess: function() {
            this.trigger('back');
        },

        onSubmit: function() {
            var model = this.model;
            if (!model.isFromCanada()) {
                model.set('province', null);
            }
        },

        onRefreshConfirm: function(result) {
            if (result) window.location.reload();
        }

    });

    return VPersonalInfoEditContent;
});

